import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Field } from 'nallian-shared-ui/lib/components';
import { useTranslation } from 'react-i18next';
import { formatNumber, validatePhoneNumberLength } from 'libphonenumber-js';
import { isValidEmail, generateErrorsForRequiredFields } from 'nallian-shared-ui/lib/lib/validate';
import {
  InputFieldValueComponent,
  PhoneFieldValueComponent,
} from 'nallian-shared-ui/lib/components/redux-form-semantic-ui';
import { FormModal } from 'nallian-shared-ui/lib/modules';

const REQUIRED_FIELDS = [];

const validateEmailError = email => !email || email.length < 0 || !isValidEmail(email);

const validatePhoneNumberError = (phone = '') => {
  // returns to long, to short or undefined
  return validatePhoneNumberLength(phone) || !formatNumber(phone, 'E.164');
};

const validate = (values, { t }) => {
  let errors = {};
  errors = generateErrorsForRequiredFields(REQUIRED_FIELDS, values, errors);

  if (validateEmailError(values.emailAddress) && validatePhoneNumberError(values.phoneNumber)) {
    errors.emailAddress = t('emailOrPhoneNumberRequiredError');
    errors.phoneNumber = t('emailOrPhoneNumberRequiredError');
  } else {
    if (validatePhoneNumberError(values.phoneNumber) && validateEmailError(values.emailAddress)) {
      errors.emailAddress = t('emailAddressEmptyErr');
    }

    if (validateEmailError(values.emailAddress) && validatePhoneNumberError(values.phoneNumber)) {
      errors.phoneNumber = t('primaryPhoneNumberEmptyErr');
    }
  }

  return errors;
};

const ContactForm = ({ submitProcessing, dataLoading, data, returnRoute, onSubmit, header }) => {
  const { t } = useTranslation();

  return (
    <FormModal
      closeIcon
      header={header}
      dataLoading={dataLoading}
      submitProcessing={submitProcessing}
      onSubmit={onSubmit}
      data={data}
      t={t}
      validate={validate}
      form="contactForm"
      cancelRoute={returnRoute}
      saveButtonIcon="save"
      saveButtonContent={t('save')}
      cancelButtonContent={t('cancel')}
    >
      <Grid>
        <Grid.Column mobile={8} tablet={8} computer={8}>
          <Field
            fluid
            label={t('emailAddress')}
            name="emailAddress"
            valueComponent={InputFieldValueComponent}
            disabled={submitProcessing || dataLoading}
          />
        </Grid.Column>
        <Grid.Column mobile={8} tablet={8} computer={8}>
          <Field
            fluid
            label={t('phoneNumber')}
            name="phoneNumber"
            valueComponent={PhoneFieldValueComponent}
            disabled={submitProcessing || dataLoading}
          />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={16}>
          <Field
            fluid
            label={t('description')}
            name="description"
            valueComponent={InputFieldValueComponent}
            disabled={submitProcessing || dataLoading}
          />
        </Grid.Column>
      </Grid>
    </FormModal>
  );
};

ContactForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  dataLoading: PropTypes.bool,
  submitProcessing: PropTypes.bool,
  header: PropTypes.string.isRequired,
  returnRoute: PropTypes.string.isRequired,
  data: PropTypes.object,
  editMode: PropTypes.bool,
};

ContactForm.defaultProps = {
  dataLoading: false,
  submitProcessing: false,
  data: {},
  editMode: false,
};

export default ContactForm;
